var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"h-100 scrollable"},[_c('base-status-diagram',{attrs:{"value":_vm.value.product,"selected":_vm.value.status,"no-icons":"","disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }